const ETH_ADDR_RE = /^0x[0-9a-fA-F]{40}$/;

export function validateEthAddress(addr: string): boolean {
  return ETH_ADDR_RE.test(addr);
}
